// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// absolute imports
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import 'core-js/es/promise';
import 'core-js/es/string';
import 'core-js/es/array';
import CountTo from 'vue-count-to';
import Toasted from 'vue-toasted';

import _ from 'lodash';
import axios from 'axios';
import numeral from 'numeral';
import moment from 'moment';
import VueSocketIO from 'vue-socket.io';
import { VueMasonryPlugin } from 'vue-masonry';

import Vue from 'vue';
import './_bootstrap-vue';
import VueClipboard from 'vue-clipboard2';
import App from './App';
import router from './router';
import store from './store/index';
import { BASE_URL, getToken } from './utils';

import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HistogramBellCurve from 'highcharts/modules/histogram-bellcurve';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsExportData from 'highcharts/modules/export-data';
import HighchartsFullscreen from 'highcharts/modules/full-screen';
import registerAuthMiddleware from './authentication';
import registerBetaMiddleware from './betaRouting';
import DarkTheme from 'highcharts/themes/dark-unica';
import HighchartsVue from 'highcharts-vue';
import HighchartsNoData from "highcharts/modules/no-data-to-display";
import mapInit from 'highcharts/modules/map'
import addWorldMap from "./components/Insights/testmap";
import VueMobileDetection from "vue-mobile-detection";
import {IS_BETA} from './localization';

HighchartsMore(Highcharts);
HistogramBellCurve(Highcharts);
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);
HighchartsFullscreen(Highcharts);
DarkTheme(Highcharts);
HighchartsNoData(Highcharts);
mapInit(Highcharts);
addWorldMap(Highcharts);

Vue.use(VueMobileDetection);

Highcharts.setOptions({
    colors: ['#00aaff', ...Highcharts.getOptions()
        .colors
        .slice(1)
    ],
    chart: {
        backgroundColor: '#3a4149',
        style: {
            fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif',
            fontSize: '12px'
        }
    },
    title: {
        style: {
            fontSize: '12px',
            fontWeight: "bold"
        }
    },
    legend: {
        itemStyle: {
            "fontSize": "11px"
        }
    },
    lang: {
        numericSymbols: ["k", "M", "B", "T", "P", "E"]
    }
});

axios.interceptors.request.use(config => {
    if (!config.url.includes('amazonaws.com')) {
        config.headers['Authorization'] = getToken();
    }
    try {
        console.log({
            url: config.url,
            method: config.method,
            params: config.params
        });
    } catch (e) {
        console.log(e);
    }
    return config;
});

axios.interceptors.response.use(response => {
    console.log(response.request.responseURL, response.data);
    return response;
});


Vue.config.devtools = true;

// bootstrap vue global
Vue.use(Toasted);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueMasonryPlugin);
Vue.use(HighchartsVue);
Vue.use(VueClipboard);

Vue.config.productionTip = true;
Vue.component('count-to', CountTo);

Vue.prototype.$baseURL = BASE_URL;

Vue.use(new VueSocketIO({
    debug: true,
    connection: BASE_URL,
}));

Vue.mixin({
    filters: {
        formatMoney: x => numeral(x)
            .format('0,0.00'),
        formatInt: x => numeral(x)
            .format('0,0'),
        humanize: x => moment.utc(x)
            .fromNow(),
        fileName: id => `${_.capitalize(id)} Data File`,
        formatSize: size => {
            const suffix = ['TB', 'GB', 'MB', 'KB'];
            const len = suffix.length;
            for (let i = 0; i < len; i++) {
                const base = Math.pow(1024, len - i);
                if (size > base) return `${(size / base).toFixed(2)} ${suffix[i]}`;
            }
            return `${size.toString()} B`;
        }
    },

    methods: {
        rand(min, max) {
            return Math.floor(Math.random() * (max - min)) + min;
        }
    },

    computed: {
        isBeta() {
            return IS_BETA;
        }
    }
});

registerAuthMiddleware(router);
registerBetaMiddleware(router);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: {App},
    template: '<App/>',
});